document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isMobile=window.innerWidth<=768;

    function initDesktopReviewMarquee() {
        const container = document.querySelector('.pdpReviewCnt');
        if (!container) return;
        const slider = container.querySelector('.pdpReviewLoopTrack');
        const prevBtn = container.querySelector('.thismarquee-prev');
        const nextBtn = container.querySelector('.thismarquee-next');
        if (!slider || !prevBtn || !nextBtn) return;
        function getScrollAmount() {
            const firstSlide = slider.querySelector('.pdpReviewSlideMn');
            return firstSlide ? firstSlide.offsetWidth + 20 : 300; 
        }
        nextBtn.addEventListener('click', () => {
            slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
        prevBtn.addEventListener('click', () => {
            slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        function updateArrowState() {
            const scrollLeft = slider.scrollLeft;
            const scrollWidth = slider.scrollWidth;
            const clientWidth = slider.clientWidth;
            if (scrollLeft <= 0) {
                prevBtn.classList.add('disabled');
            } else {
                prevBtn.classList.remove('disabled');
            }
            if (scrollLeft + clientWidth >= scrollWidth - 2) {
                nextBtn.classList.add('disabled');
            } else {
                nextBtn.classList.remove('disabled');
            }
        }
        slider.addEventListener('scroll', updateArrowState);
        updateArrowState();
        window.addEventListener('resize', updateArrowState);
        let isDown = false;
        let startX;
        let scrollLeftDrag;
        slider.addEventListener('mousedown', (e) => {
            if (e.button !== 0) return;
            isDown = true;
            slider.classList.add('active');
            slider.style.scrollSnapType = 'none';
            startX = e.pageX - slider.offsetLeft;
            scrollLeftDrag = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
            slider.style.scrollSnapType = '';
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
            slider.style.scrollSnapType = '';
            updateArrowState();
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1.5;
            slider.scrollLeft = scrollLeftDrag - walk;
            updateArrowState();
        });
    }
    function checkWidthAndInit() {
        if (window.innerWidth > 749) { initDesktopReviewMarquee(); }
    }
    checkWidthAndInit();
    window.addEventListener('resize', checkWidthAndInit);

    let MediaThumbnailView = new Swiper('[js-swiper-thumbnail-images]', {
        slidesPerView: 5,
        spaceBetween: 12,
        loop: false,
        watchSlidesProgress: true,
        breakpoints: { 749: { slidesPerView: 6 } }
    });

    let MediaMainProductView = new Swiper('[js-swiper-main-images]', {
        autoHeight: true,
        centeredSlides: false,
        loop: false, slidesPerView: 1,
        spaceBetween: 15,
        thumbs: { swiper: MediaThumbnailView } 
    });

    document?.querySelectorAll(`[js-faq-tabs]`)?.forEach((el)=>{
        el.addEventListener('click', (target)=>{
            let targetTabIndex = target.currentTarget.dataset.tabId; 
            target.target.closest(`[js-tabs-main-outer]`).querySelectorAll(`[js-faq-tabs]`).forEach((el)=>{ el.classList.remove('active') });
            target.target.closest(`[js-tabs-main-outer]`).querySelectorAll(`[js-tabs-outer-container]`).forEach((el)=>{ el.classList.remove('active') });
            target.currentTarget.classList.add('active');
            target.target.closest(`[js-tabs-main-outer]`).querySelector(`[js-tabs-outer-container][data-tab="${targetTabIndex}"]`).classList.add('active');
        })
    })    

    const collapsibleTabOpenTime = (target)=>{
        target.target.closest('[js-collapsible-outer]').classList.toggle('active');
        if( target.target.closest(`[js-collapsible-parent]`).hasAttribute(`js-holding-many-faqs`) ){
        }else{
            target?.target?.closest('[js-main-collapsible-father]')?.querySelectorAll(`[js-collapsible-parent]`)?.forEach((el)=>{
                el.querySelectorAll(`[js-collapsible-outer]`).forEach((tg)=>{
                    if(target.target.closest('[js-collapsible-outer]') != tg ){
                        tg.classList.remove('active');
                        tg.querySelector('[js-collapsible-content]').style.maxHeight = null;
                    }
                })
            })
        }
        if ( target.target.closest('[js-collapsible-outer]').classList.contains('active') ){
            target.target.closest(`[js-collapsible-parent]`).querySelectorAll(`[js-collapsible-outer]`).forEach((elm)=>{ 
                if(target.target.closest('[js-collapsible-outer]') != elm ){
                    elm.classList.remove('active');
                    elm.querySelector('[js-collapsible-content]').style.maxHeight = null;
                }
            })
            if( target.target.closest(`[js-collapsible-parent]`).hasAttribute(`js-holding-many-faqs`) ){
                let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
                let HoldManyFaqsHeight = target.target.closest('[js-collapsible-content]').scrollHeight;
                let FinalHeightOfAll = HoldManyFaqsHeight+HeightElementData.scrollHeight;
                target.target.closest('[js-collapsible-content]').style.maxHeight = `${FinalHeightOfAll}px`;
                target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
                setTimeout(()=>{
                    window.scrollTo({
                        top: target.target.closest('[js-collapsible-outer]').offsetTop - 90,
                        behavior: 'smooth'
                    });    
                },550)            
            }else{
                let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
                target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
                setTimeout(()=>{
                    window.scrollTo({
                        top: target.target.closest('[js-collapsible-outer]').offsetTop - 90,
                        behavior: 'smooth'
                    });    
                },550)                
            }
        }else{
            if( target.target.closest(`[js-collapsible-parent]`).hasAttribute(`js-holding-many-faqs`) ){
                target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
                setTimeout(()=>{
                    let HoldManyFaqsHeightRm = target.target.closest('[js-collapsible-content]').scrollHeight;
                    console.log(HoldManyFaqsHeightRm);
                    target.target.closest('[js-collapsible-content]').style.maxHeight = `${HoldManyFaqsHeightRm}px`;
                },550)
            }else{
                target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
            }
        }        
    }

    document?.querySelectorAll('[js-collapsible-header]')?.forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            collapsibleTabOpenTime(target);
        })
    });  

    const reviewContainers = document.querySelectorAll('[js-media-hover-init]');
    if (reviewContainers.length > 0) {
        reviewContainers.forEach(container => {
            const videoWrapper = container.querySelector('[data-video-wrapper]');
            const videoUrl = videoWrapper.getAttribute('data-video-src');
            const contentArea = container.querySelector('[js-video-loaded-el]');
            container.addEventListener('mouseenter', function() {
                if (videoWrapper.classList.contains('video__nline')) return;
                if (!container.querySelector('.this_media__previwing')) {
                    const videoHtml = `
                    <div class="this_media__previwing">
                        <video class="review-video-element" loop muted playsinline autoplay>
                            <source src="${videoUrl}" type="video/mp4">
                        </video>
                    </div>`;
                    contentArea.insertAdjacentHTML('beforeend', videoHtml);
                }
                videoWrapper.classList.add('video__pvv');
            });
            container.addEventListener('mouseleave', function() {
                if (videoWrapper.classList.contains('video__nline')) return;
                videoWrapper.classList.remove('video__pvv');
                const previewDiv = container.querySelector('.this_media__previwing');
                if (previewDiv) previewDiv.remove();
            });
            container.addEventListener('click', function(e) {
                e.preventDefault(); 
                const modalOverlay = document.createElement('div');
                modalOverlay.style.cssText = `
                    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(0, 0, 0, 0.85); z-index: 99999;
                    display: flex; justify-content: center; align-items: center;
                    opacity: 0; transition: opacity 0.3s ease;
                `;
                const modalContent = document.createElement('div');
                modalContent.style.cssText = `position: relative; border-radius: 8px; overflow: hidden;`;
                const closeBtn = document.createElement('button');
                closeBtn.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>`;
                closeBtn.style.cssText = `
                    position: absolute; top: 15px; right: 15px;
                    background: rgba(0,0,0,0.5); border: none; border-radius: 50%;
                    width: 40px; height: 40px; display: flex; justify-content: center; align-items: center;
                    cursor: pointer; z-index: 10000; transition: background 0.2s;
                `;
                closeBtn.onmouseover = () => closeBtn.style.background = 'rgba(0,0,0,0.8)';
                closeBtn.onmouseout = () => closeBtn.style.background = 'rgba(0,0,0,0.5)';
    
                const videoEl = document.createElement('video');
                videoEl.src = videoUrl;
                videoEl.controls = true;
                videoEl.autoplay = true;
                videoEl.setAttribute('playsinline', '');
                videoEl.setAttribute('webkit-playsinline', '');
                videoEl.style.cssText = 'width: 100%; height: auto; max-height: 85vh; display: block;';
    
                modalContent.appendChild(closeBtn);
                modalContent.appendChild(videoEl);
                modalOverlay.appendChild(modalContent);
                document.body.appendChild(modalOverlay);
    
                document.body.classList.add('overflow-hidden');
    
                setTimeout(() => { modalOverlay.style.opacity = '1'; }, 10);

                const closeModal = () => {
                    modalOverlay.style.opacity = '0';
                    videoEl.pause();
                    videoEl.src = "";
                    videoEl.load();                    
                    document.body.classList.remove('overflow-hidden');
                    setTimeout(() => { modalOverlay.remove(); }, 300);
                };
                closeBtn.addEventListener('click', closeModal);
                modalOverlay.addEventListener('click', (event) => {
                    if (event.target === modalOverlay) closeModal();
                });
            });
        });
    }

    document.querySelectorAll("[js-flipped-column]").forEach(item => {
        if (!item.querySelector(".expertFace.expertBack")) return
        item.addEventListener("click", () => {
            item.classList.toggle("is-flipped")
        })
    })

    const more = document.querySelectorAll(".has__mor_option");
    const buttons = document.querySelectorAll(".many_more_yup");
    buttons.forEach(btn => btn.addEventListener("click", () => {
        more.forEach(el => {
            el.classList.toggle("open");
            if (el.classList.contains("open")) {
                el.style.maxHeight = el.scrollHeight + "px";
            } else {
                el.style.maxHeight = "0px";
            }
        });
        const isOpen = more[0].classList.contains("open");
        buttons.forEach(b => b.textContent = isOpen ? "See Less" : "See More");
    }));

    const progressContainers = document.querySelectorAll('.icon_outercontainer_g');
    if (progressContainers.length > 0) {
        const animateElement = (container) => {
            const target = parseInt(container.getAttribute('data-target')) || 0;
            const circle = container.querySelector('.progress');
            const valueDisplay = container.querySelector('.icon_boltap_g');
            let dot = container.querySelector('.circular-progress-circle');
            if (!dot) {
                dot = document.createElement('div');
                dot.className = 'circular-progress-circle';
                container.appendChild(dot);
            }
            const duration = 2000; 
            const maxTranslate = 100;
            const radius = circle.r.baseVal.value;
            const circumference = 2 * Math.PI * radius;
            circle.style.transition = "none";
            dot.style.transition = "none";
            circle.style.strokeDasharray = `${circumference}`;
            circle.style.strokeDashoffset = `${circumference}`;
            circle.style.visibility = "visible";
            let startTime = null;
            const step = (timestamp) => {
                if (!startTime) startTime = timestamp;
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeOut = 1 - Math.pow(1 - progress, 3);
                const currentPercent = easeOut * (target / 100);
                const currentCount = Math.floor(easeOut * target);
                valueDisplay.textContent = `${currentCount}%`;
                const offset = circumference - (currentPercent * circumference);
                circle.style.strokeDashoffset = offset;
                const currentTranslate = currentPercent * maxTranslate;
                dot.style.transform = `rotate(-90deg) `;
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                } else {
                    valueDisplay.textContent = `${target}%`;
                    dot.style.transform = `rotate(-90deg) `;
                }
            };
            window.requestAnimationFrame(step);
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateElement(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });
        progressContainers.forEach(container => observer.observe(container));
    }

    if( document.querySelectorAll('.thispdp__buybox_layout').length > 0 ){
    const anchor = document.querySelectorAll('a[href^="#reviews"]');
    if (anchor.length > 0) {
        anchor.forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                const targetElement = document.querySelector('.stamped__widget__wp');
                if (targetElement) {
                    e.preventDefault();
                    window.scrollTo({
                        top: targetElement.offsetTop - 91,
                        behavior: 'smooth'
                    });
                }
            })
        })
    }

    
        document.querySelector(`.this_buypdp__upsell-inputs`).querySelector(`input`).addEventListener('change', (e) => {
            const buyButton = document.querySelector(`cdv-buy-button`);
            const priceContainer = buyButton.querySelector(`.this__buy_btn_cart__price`);
            const currency = buyButton.dataset.currency;
            let priceProduct = parseFloat(buyButton.getAttribute('price')) / 100;
            let comparePriceProduct = parseFloat(buyButton.getAttribute('compare-price')) / 100;
            if (e.target.checked === true) {
                let priceWarranty = parseFloat(e.target.dataset.price) / 100;
                let comparePriceWarranty = parseFloat(e.target.dataset.comparePrice) / 100;
                let finalPrice = Math.round(priceProduct + priceWarranty);
                let finalComparePrice = Math.round(comparePriceProduct + comparePriceWarranty);
                priceContainer.querySelector('.this__buy_btn_cart_cp_price').innerHTML = `<s>${currency}${finalComparePrice}</s>`;
                priceContainer.querySelector('.this__buy_btn_cart_pp_price').innerHTML = `${currency}${finalPrice}`;
            } else {
                let originalPrice = Math.round(priceProduct);
                let originalCompare = Math.round(comparePriceProduct);
                priceContainer.querySelector('.this__buy_btn_cart_cp_price').innerHTML = `<s>${currency}${originalCompare}</s>`;
                priceContainer.querySelector('.this__buy_btn_cart_pp_price').innerHTML = `${currency}${originalPrice}`;
            }
        })
    }

    class BuyButtonAction extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', this.handleClick.bind(this));
        }
        async handleClick() {
            let variantId = this.dataset.product;
            const upsellContainer = document.querySelector('.this_buypdp__upsell-inputs');
            if (upsellContainer) {
                const upsellInput = upsellContainer.querySelector('input');
                if (upsellInput && upsellInput.checked) {
                    variantId = upsellInput.value;
                }
            }
            if (!variantId) {
                console.error("No Variant ID found");
                return;
            }
            await this.BypassCheckout(variantId);
        }
        async BypassCheckout(target) {
            this.style.pointerEvents = "none";
            this.classList.add('active');
            const loader = this.querySelector('.this__buy_btn_cart__loader');
            if (loader) loader.classList.remove('hidden');
            const formData = {
                'items': [{
                    'id': target,
                    'quantity': 1
                }]
            };
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
                if (response.ok) {
                    this.resetState();
                    window.location.href = '/checkout';
                } else {
                    const errorData = await response.json();
                    this.resetState();
                }
            } catch (error) {
                console.error('Network error:', error);
                this.resetState();
            }
        }
        resetState() {
            this.classList.remove('active');
            this.style.pointerEvents = "all";
            const loader = this.querySelector('.this__buy_btn_cart__loader');
            if (loader) loader.classList.add('hidden');
        }
    }
    customElements.define('cdv-buy-button', BuyButtonAction);

    if (document.querySelectorAll(`.this_buypdp__upsell-inputs`).length > 0) {
    const modals = document.createElement("div")
    modals.id = "modals"
    document.body.append(modals)

    function makeModal(title, content, id, args = {}) {
        const container = document.createElement("div");
        if (id) {
            container.id = id;
        }
        container.classList.add("thisOwn_modal-container");
        if (args.type) {
            container.classList.add(`modal-type-${args.type}`);
        }
        container.setAttribute("tabindex", "-1");
        console.log("title value is ", id);
        if (id == "video-modal") {
            container.innerHTML = `
            <div class="video-model-element">
                <div class="video-model-row">
                    <div class="title-vidoe">${title ?? "Modal"}</div>
                    <button class="video-model-close">
                        <svg width="28" height="28" viewBox="0 0 24 24"><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>
                    </button>
                </div>
                <div class="vidoe-modle-contents"></div>
            </div>
            `;
        } else {
            container.innerHTML = `
            <div class="thisOwn_modal-element">
                <div class="thisOwn_modal-title-row">
                    <div class="thisOwn_modal-title">${title ?? "Modal"}</div>
                    <button class="thisOwn_modal-close">
                        <svg width="28" height="28" viewBox="0 0 24 24"><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>
                    </button>
                </div>
                <div class="thisOwn_modal-contents"></div>
            </div>
            `;
        }
    
        const contents = container.querySelector(".thisOwn_modal-contents, .vidoe-modle-contents");
        if (typeof content === "string") {
            contents.innerHTML = content;
        } else {
            contents.append(...content.map(node => node.cloneNode(true)));
        }
        return container;
    }
 
    function handleModal(modal, close, func) {
        const closeBtn = modal.querySelector(".thisOwn_modal-close, .video-model-close");
        if (closeBtn) {
            closeBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                close();
            });
        }
    
        let down;
        modal.addEventListener("mousedown", e => down = e.target);
        modal.addEventListener("mouseup", e => {
            if (down === e.target && e.target.classList.contains("thisOwn_modal-container")) {
                close();
            }
        });
    
        modal.addEventListener("keydown", e => {
            if (e.key === "Escape") {
                close();
            } else if (e.key === "Tab") {
                const focusable = modal.querySelectorAll(
                    'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
                if (!focusable.length) return;
                const first = focusable[0];
                const last = focusable[focusable.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });
    
        if (modal.id) {
            const existingModal = document.getElementById(modal.id);
            if (existingModal) {
                existingModal.remove();
            }
        }
    
        modals.append(modal);
    
        if (func) {
            modal.modalElement = modal.querySelector(".thisOwn_modal-element, .video-model-element");
            if (modal.modalElement) {
                modal.modalElement.close = close;
                func(modal.modalElement);
            }
        }
    }

    window.openModal = (title, content, id, func, args = {}) => {
        return new Promise(fulfil => {
        const modal = makeModal(title, content, id, args)
        modal.classList.add("opening")
        function close() {
            if (modal.modalElement?.locked) return
            modal.classList.remove("open")
            modal.classList.add("closing")
            setTimeout(() => {
            modal.remove()
            const all = modals.querySelectorAll(".thisOwn_modal-container")
            if (all.length) {
                all[all.length - 1].focus()
            }
            fulfil()
            }, args.transitionDuration ?? 150)
        }
        handleModal(modal, close, func)
        setTimeout(() => {
            modal.classList.remove("opening")
            modal.classList.add("open")
            const focusable = modal.querySelectorAll(
            'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
            )
            if (focusable.length > 1) {
            focusable[1].focus()
            } else {
            modal.focus()
            }
        }, 0)
        })
    }
 
    let isModalOpen = false;
    window.openModal = (title, content, id, func, args = {}) => {
        if (isModalOpen) {
            console.log("A modal is already open. Ignoring duplicate request.");
            return Promise.resolve();
        }
    
        return new Promise(fulfil => {
            isModalOpen = true;
            document.body.classList.add("overflow-hidden");
            const modal = makeModal(title, content, id, args);
            modal.classList.add("opening");
            function close() {
                if (modal.modalElement?.locked) return;
                modal.classList.remove("open");
                modal.classList.add("closing");
                document.body.classList.remove("overflow-hidden");
                setTimeout(() => {
                    modal.remove();
                    const all = modals.querySelectorAll(".thisOwn_modal-container");
                    if (all.length) {
                        all[all.length - 1].focus();
                    }
                    isModalOpen = false;
                    fulfil();
                }, args.transitionDuration ?? 150);
            }
        
            handleModal(modal, close, func);
        
            setTimeout(() => {
                modal.classList.remove("opening");
                modal.classList.add("open");
                const focusable = modal.querySelectorAll(
                    'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
                if (focusable.length > 1) {
                    focusable[1].focus();
                } else {
                    modal.focus();
                }
            }, 0);
        });
    };
 
    document.addEventListener("click", e => {
        const el = e.target.closest("[data-modal], .modal")
        if (!el) return
 
        if (el.hasAttribute("data-modal")) {
        openModal(
            el.dataset.modalTitle,
            el.dataset.modal,
            el.dataset.modalId,
            null,
            el.dataset.modalType
        )
        return
        }
 
        const modals = document.querySelectorAll(".thisOwn_modal")
        for (const modal of modals) {
        if (!modal.dataset.trigger) continue
        if (e.target.closest("." + modal.dataset.trigger)) {
            if (!modal._modalData) {
            modal._modalData = {
                title: modal.dataset.title,
                content: [...modal.children],
                id: modal.dataset.modalId ?? modal.dataset.trigger + "-modal",
                type: modal.dataset.modalType
            }
            }
 
            const d = modal._modalData
            openModal(d.title, d.content, d.id, null, d.type)
            return
        }
        }
    })
 
    document.body.addEventListener("click", e => {
        const link = e.target.closest("a[href^='#']")
        if (!link) return
 
        const id = link.getAttribute("href").slice(1)
        if (!id) return
 
        const modalMatches = Array.from(document.querySelectorAll(`#modal-content-${id}`))
        if (modalMatches.length) {
            const modalContent = modalMatches[modalMatches.length - 1]
            e.preventDefault()
            showAnchorModal(JSON.parse(modalContent.textContent))
            return
        }
 
        const target = document.querySelector(id.startsWith(".") || id.startsWith("[") ? id : `#${id}`)
        if (!target) return
 
        e.preventDefault()
        smoothScroll(target)
 
        history.replaceState(null, "", window.location.pathname + window.location.search)
 
        if ("click" in link.dataset) {
            if (target.previousElementSibling?.type == "checkbox" && target.previousElementSibling?.checked) {
            return
            }
            target.click()
        }
    })

    window.smoothScroll = (element, args = {}) => {
        let el = element

        while (el && getComputedStyle(el).display === "none") {
            el = el.nextElementSibling
        }

        if (!el) el = element

        if (args.lazy) {
            const rect = el.getBoundingClientRect()
            if (rect.top >= 0 && rect.top <= window.innerHeight) return
        }

        let attempts = 0
        let lastTop = null

        function scroll() {
            const top = getElementTop(el)
            if (lastTop !== null && Math.abs(top - lastTop) < 2) return
            lastTop = top

            window.scrollTo({ top, behavior: "smooth" })
            attempts++
            if (attempts < 4) setTimeout(scroll, 500)
        }

        scroll()
    }

    function showAnchorModal(data) {
        history.replaceState(null, "", location.pathname + location.search)
        let style = "<style>"
        if (data.width > 0) {
        style += `.thisOwn_modal-contents { width: clamp(var(--modal-min-width), ${data.width}px, var(--modal-max-width)); }\n`
        }
        let content = ""
        const id = data.contentType === "video" ? "video-modal" : "modal-" + Math.random().toString(16).replace("0.", "")
        if (data.contentType === "with_image") {
        content += `
            <div class="thisOwn_modal-with-image-top">
                <div class="thisOwn_richtext">${data.content.imageContent}</div>
                   ${data.content.image ? `<img src="${data.content.image}">` : ""}
                </div>
            <div class="thisOwn_richtext">${data.content.secondaryContent}</div>
        `
        } else if (data.contentType === "iframe") {
        content += `<iframe src="${data.content.iframeURL}"></iframe>`
        style += `
            #${id} .modal-contents {
                padding: 0;
            }
            #${id} iframe {
                display: block;
                border: none;
                width: 100%;
                height: var(--modal-max-height);
            }
        `
        } else if (data.contentType === "images") {
            content += data.content.images.map(e => `<img src="${e}">`).join("")
        } else if (data.contentType === "video") {
            content += `<video controls playsinline src="${data.content.video}"${data.content.autoplay ? " autoplay" : ""}></video>`
        } else {
            content += data.content.content
        }
        style += "</style>"
        if (style !== "<style></style>") {
            content += style
        }
        openModal(data.content.title, content, id, null, data)
    } 

    document.addEventListener('click', function(e) {
        if (e.target.closest('.thispdp__buybox_richtext a')) {
            document.body.classList.add('overflow-hidden');
        }else if (e.target.closest('.thisOwn_modal-close')) {
            document.body.classList.remove('overflow-hidden');
        }else if(e.target.closest('.multi_comparisonwp_tb_media a')) {
            document.body.classList.add('overflow-hidden');
        }else if(e.target.closest('.thisOwn_modal-close')) {
            document.body.classList.remove('overflow-hidden');
        }        
   });

    const targetSpan = document.querySelector('.fetchdelivery-date');
    if (!targetSpan) return;
    const observer = new MutationObserver(() => {
        const sourceSpan = document.querySelector('.this_buypdp__buybutton_delivery-date');
        if (sourceSpan && sourceSpan.textContent.trim() !== '') {
            targetSpan.textContent = sourceSpan.textContent.trim();
            observer.disconnect();
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
    });

}

})

